(function () {
  const mobileOrTablet = window.matchMedia('(max-width: 1024px)');
  const timers = new WeakMap();

  function setupAutoScroll() {
    if (!mobileOrTablet.matches) return;

    // Instafeed renders more than one layout, so match any of its containers in
    // either feed section and keep only the one that actually scrolls sideways.
    const SECTIONS = ['[id*="section_eMy9bg"]', '[id*="section_RRQ6AE"]'];
    const CONTAINERS = [
      '.instafeed-new-layout-container',
      '#insta-feed',
      '#insta-feed > div',
      '.instafeed-container',
      '.instafeed-feed',
      '.instafeed-wrapper',
      '[class*="instafeed"]',
    ];
    const selector = SECTIONS.flatMap((section) =>
      CONTAINERS.map((container) => `${section} ${container}`)
    ).join(', ');

    const tracks = Array.from(document.querySelectorAll(selector)).filter(
      (candidate) => candidate instanceof HTMLElement && candidate.scrollWidth - candidate.clientWidth > 4
    );

    tracks.forEach((track) => {
      if (!(track instanceof HTMLElement)) return;
      if (track.dataset.tbhAutoScrollReady === '1') return;
      track.dataset.tbhAutoScrollReady = '1';

      let paused = false;
      let step = 1.1;

      const tick = () => {
        if (!mobileOrTablet.matches || paused) return;
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 0) return;

        if (track.scrollLeft >= max - 1) {
          track.scrollLeft = 0;
          return;
        }

        track.scrollLeft += step;
      };

      const start = () => {
        if (timers.has(track)) return;
        timers.set(track, window.setInterval(tick, 26));
      };

      const stop = () => {
        const timer = timers.get(track);
        if (!timer) return;
        window.clearInterval(timer);
        timers.delete(track);
      };

      track.addEventListener('pointerdown', () => {
        paused = true;
      });
      track.addEventListener('pointerup', () => {
        paused = false;
      });
      track.addEventListener('pointercancel', () => {
        paused = false;
      });
      track.addEventListener('touchstart', () => {
        paused = true;
      }, { passive: true });
      track.addEventListener('touchend', () => {
        paused = false;
      }, { passive: true });

      start();
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAutoScroll, { once: true });
  } else {
    setupAutoScroll();
  }

  const observer = new MutationObserver(() => {
    setupAutoScroll();
    if (document.querySelector('[data-tbh-auto-scroll-ready="1"]')) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // A track only becomes scrollable once its images have laid out, which no
  // mutation reports — so re-check a few times after the feed mounts.
  window.addEventListener('load', setupAutoScroll);
  [1000, 3000, 6000].forEach((delay) => window.setTimeout(setupAutoScroll, delay));
})();
